import API from '@/api'
import { mapGetters } from 'vuex'
export const userEntity = {
    data() {
        return {
            entityData: [],
            allEntityIds: []
        }
    },
    computed: {
        ...mapGetters('common', {
            getSite: 'getSite',
            getUser: 'getUser'
        })
    },
    methods: {
        // 查询Entity信息
        getUserEntity: async function (menuId) {
            const { code, data } = await API.common.queryUserEntity({
                siteId: this.$route.query.siteId ? this.$route.query.siteId : this.getSite.siteId,
                menuId,
                userType: this.getUser.userType
            })
            if (code == '1') {
                this.entityData = [data]
                this.allEntityIds = []
                this.getAllIds(this.entityData[0])
                this.$store.commit('common/setEntityIds', this.allEntityIds)
            } else {
                this.$message.error(this.$t(code))
            }
        },
        // 获取所有node的id && 默认选中
        getAllIds(data) {
            if (!data.disabled) {
                data.checked = true
                data.id ? this.allEntityIds.push(data.id) : ''
            }
            if (data.childEntity.length > 0) {
                data.childEntity.forEach((child) => this.getAllIds(child))
            }
        }
    }
}
